import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import _ from 'lodash';
import { Subscription } from 'rxjs';
import { IChildProject } from 'src/app/models/projects/project.model';


export interface FormDialogOption {
    title?: string;
    text?: string;
    placeholder?: string;
    error?: string;
    valid?: string;
    noConfirm?: boolean;
}

@Component({
    selector: 'app-form-dialog',
    templateUrl: './form-dialog.component.html',
    styleUrls: ['./form-dialog.component.scss'],
})
export class FormDialogComponent implements OnInit, OnDestroy {

    get controls(): { [x: string]: FormControl; } { return this.form.controls as { [x: string]: FormControl; }; }

    form: FormGroup;
    title: string = '';
    text: string = '';
    placeholder: string = '';
    error: string = '';
    valid: string;
    noConfirm: boolean;
    myControl = new FormControl();

    get isValid(): boolean { return this.form.valid; }

    subscription: Subscription = new Subscription();

    constructor(
        protected fb: FormBuilder,
        protected dialogRef: MatDialogRef<FormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public config: any
    ) {

        this.title = config.title || '';
        this.text = config.text || '';
        this.placeholder = config.placeholder || '';
        this.error = config.error || '';
        this.valid = config.valid || 'YES';
        this.noConfirm = config.noConfirm;
        this.form = fb.group({});
    }

    ngOnInit() { }

    displayFn(project?: IChildProject): string | '' {
        return project ? project.name : '';
    }

    isReadOnly(): boolean {
        let res: boolean = false;
        if (!this.isValid) { res = true; }
        return res;
    }

    save(): void {
        this.dialogRef.close(_.cloneDeep(this.form.value));
    }

    close(): void {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
